import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, InputNumber, Row, Col, Tooltip, DatePicker, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { VscListSelection } from "react-icons/vsc";
import Sidebar from "../../../../Components/Common/Sidebar";
import SelectStaffs from "../Payroll/SelectStaffs";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchCategory } from "../../../../Store/Slices/Finance/Category/financeCategory.Thunk";
import Layout from '../../../../Components/Common/Layout';
import AdminDashLayout from "../../../../Components/Admin/AdminDashLayout";
import useNavHeading from "../../../../Hooks/CommonHooks/useNavHeading ";
import { fetchBudget } from "../../../../Store/Slices/Finance/budget/budget.thunk";
import { createPayroll } from "../../../../Store/Slices/Finance/payroll/payroll.thunk";
import { BsInfoCircle } from "react-icons/bs";
import dayjs from "dayjs";
import ConfigurationCreateModel from "./PayrollSaveModel";
import { useTranslation } from "react-i18next";

const { Option } = Select;

const AddPayrollManagement = () => {
  useNavHeading('HR & Payroll', "Add PayRoll");
  const { t } = useTranslation("prtFinance")
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const categories = useSelector((state) => state.admin.financialCategory.categories);
  const [form] = Form.useForm();
  const [lineItems, setLineItems] = useState([
    {
      categoryId: "",
      budgetId: "",
      salaryMonth: "",
      basicSalary: 0,
      allowances: 0,
      deductions: 0,
      tax: 0,
      netSalary: 0,
      bonus: 0,
      overtime: 0,
      leaveDeductions: 0,
      otherAdjustments: 0,
      budgets: [],
    },
  ]);
  const [description, setDescription] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [staffIds, setStaffIds] = useState([]);

  const [receiptData, setReceiptData] = useState({
    status: "pending",
    paymentType: "cash",
    paymentDate: "",
    onlineTransactionId: "",
    chequeNumber: "",
    chequeDate: "",
    note: "",
  });
  const location = useLocation();
  useEffect(() => {
    if (location?.state) {
      setLineItems(location?.state?.configData?.lineItems);
      setStaffIds(location?.state?.configData?.staffIds);
      form.setFieldsValue({
        lineItems: location?.state?.configData?.lineItems,
      });
    }
    dispatch(fetchCategory({ categoryType: "expense", search: "", page: 1, limit: 10000 }));
  }, [dispatch]);


  const handleCategoryChange = async (index, categoryId) => {
    const a = await dispatch(fetchBudget({ categoryId, page: 1, limit: 10000 }));
    const updatedItems = [...lineItems];
    updatedItems[index].categoryId = categoryId;
    updatedItems[index].budgetId = "";
    updatedItems[index].budgets = a?.payload?.data || [];
    setLineItems(updatedItems);
  };

  const handleBudgetChange = (index, budgetId) => {
    const updatedItems = [...lineItems];
    updatedItems[index].budgetId = budgetId;
    setLineItems(updatedItems);
  };

  const handleInputChange = (index, field, value) => {
    const updatedItems = [...lineItems];
    updatedItems[index][field] = field.includes('Date') && value ? value.format('YYYY-MM-DD') : value;

    const { basicSalary, allowances, deductions, tax, bonus, otherAdjustments, leaveDeductions, overtime } = updatedItems[index];
    const netSalary = basicSalary + allowances + otherAdjustments + overtime + bonus - deductions - leaveDeductions - tax;
    updatedItems[index].netSalary = netSalary;

    setLineItems(updatedItems);
  };

  const addLineItem = () => {
    setLineItems([
      ...lineItems,
      {
        categoryId: "",
        budgetId: "",
        salaryMonth: "",
        basicSalary: 0,
        allowances: 0,
        deductions: 0,
        tax: 0,
        netSalary: 0,
        bonus: 0,
        overtime: 0,
        leaveDeductions: 0,
        otherAdjustments: 0,
        budgets: [],
      },
    ]);
  };

  const removeLineItem = (index) => {
    const updatedItems = [...lineItems];
    updatedItems.splice(index, 1);
    setLineItems(updatedItems);
  };
  const copyLineItem = (index) => {
    let newone = lineItems[index];
    const updatedItems = [...lineItems, {
      categoryId: newone?.categoryId,
      budgetId: newone?.budgetId,
      salaryMonth: lineItems[index]?.salaryMonth,
      basicSalary: newone?.basicSalary,
      allowances: newone?.allowances,
      deductions: newone?.deductions,
      tax: newone?.tax,
      netSalary: newone?.netSalary,
      bonus: newone?.bonus,
      overtime: newone?.overtime,
      leaveDeductions: newone?.leaveDeductions,
      otherAdjustments: newone?.otherAdjustments,
      budgets: newone?.budgets,
    }]
    setLineItems(updatedItems);
  };
  const [configModel, setConfigModel] = useState(false);
  const [isConfigData, setIsConfigData] = useState(false);
  const closeConfigModel = () => {
    setIsConfigData(false)
    setConfigModel(false)
  }
  const handleSubmit = (values) => {
    if (staffIds.length < 1) {
      toast.error(t("Please select User"));
      return;
    }
    const data = {
      description,
      lineItems,
      staffIds,
      ...receiptData,
    };
    if (isConfigData) {
      setConfigModel(true)
      return
    } else {
      dispatch(createPayroll({ data, navigate }));
    }
  };

  const handleChange = (field, value) => {
    setReceiptData({
      ...receiptData,
      [field]: field.includes('Date') && value ? value.format('YYYY-MM-DD') : value,
    });
  };

  const months = [
    "January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"
  ];
  const { activeYear } = useSelector((store) => store.common.financialYear);
  const minDate = dayjs(activeYear?.startDate?.slice(0, 10));
  const maxDate = dayjs(activeYear?.endDate?.slice(0, 10));


  return (
    <Layout title="Finance | PayRoll">
      <AdminDashLayout>
        <div className="p-6">
          <div className="flex items-center justify-between mb-2">
            <div>
              <h1 className="font-bold">{t("Add PayRoll")}</h1>
             
            </div>
            <div>
             <button
                className="flex flex-row items-center gap-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white px-2  py-2 rounded-xl shadow-lg"
                onClick={() => setIsModalVisible(true)}
              >
                {t("Select User")} <span><VscListSelection /></span>
              </button>
            </div>
          </div>

          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            {/* Payroll Details */}
            {lineItems.map((item, index) => (
              <div key={index} className="p-4 border rounded-xl bg-gray-100 gap-y-4 mb-4">
                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "categoryId"]}
                      label={
                        <span className="flex items-center gap-1">
                          <span className="font-medium">{t("Category")}</span>
                          <Tooltip
                            title={
                              <>
                                <div className="text-xs">{t("Shows Expense categories only.")}
                                  {t("Use this to track Salary/Payroll.")}  </div>

                              </>
                            }
                          >
                            <BsInfoCircle className="cursor-pointer" />
                          </Tooltip>
                        </span>
                      }
                      required>
                      <Select
                        style={{ width: "100%" }}
                        value={item.categoryId}
                        onChange={(value) => handleCategoryChange(index, value)}
                      >
                        {categories.map((cat) => (
                          <Option key={cat._id} value={cat._id}>
                            {cat.categoryName}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "budgetId"]} label={t("Sub Category")} required>
                      <Select
                        style={{ width: "100%" }}
                        value={item.budgetId}
                        onChange={(value) => handleBudgetChange(index, value)}
                      >
                        {item.budgets?.map((budget, idx) => (
                          <Option key={idx} value={budget._id}>
                            {budget.subCategory}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "salaryMonth"]} label={t("Salary Month")} required>
                      <Select
                        style={{ width: "100%" }}
                        value={item.salaryMonth}
                        onChange={(value) => handleInputChange(index, "salaryMonth", value)}
                      >
                        {months.map((month, idx) => (
                          <Option key={idx} value={month}>
                            {month}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "basicSalary"]} label={t("Basic Salary")} required>
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        value={item.basicSalary}
                        onChange={(value) => handleInputChange(index, "basicSalary", value)}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "allowances"]} label={t("Allowances")} required>
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        value={item.allowances}
                        onChange={(value) => handleInputChange(index, "allowances", value)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "leaveDeductions"]} label={t("Leave Deductions")} required>
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        value={item.allowances}
                        onChange={(value) => handleInputChange(index, "leaveDeductions", value)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "overtime"]} label={t("Over time")} required>
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        value={item.allowances}
                        onChange={(value) => handleInputChange(index, "overtime", value)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "otherAdjustments"]} label={t("Other Adjustments")} required>
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        value={item.allowances}
                        onChange={(value) => handleInputChange(index, "otherAdjustments", value)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "deductions"]} label={t("Deductions")} required>
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        value={item.deductions}
                        onChange={(value) => handleInputChange(index, "deductions", value)}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "tax"]} label={t("Tax")} required>
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        value={item.tax}
                        onChange={(value) => handleInputChange(index, "tax", value)}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "bonus"]} label={t("Bonus")} required>
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        value={item.bonus}
                        onChange={(value) => handleInputChange(index, "bonus", value)}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item name={["lineItems", index, "netSalary"]} label={t("Net Salary")}>
                      <p className="font-bold">{item.netSalary}</p>
                    </Form.Item>
                  </Col>
                </Row>

                <Button danger onClick={() => removeLineItem(index)}>{t("Remove")}</Button>
                <Button  onClick={() => copyLineItem(index)} className="ml-10 border border-blue-500 text-blue-500">{t("Copy")}</Button>
              </div>
            ))}

            <Button type="dashed" onClick={addLineItem} className="text-purple-500">{t("Add New Item")}</Button>
            <Button htmlType="submit" onClick={()=> setIsConfigData(true)}  className=" ml-10 bg-gradient-to-r from-pink-500 to-purple-500 text-white">{t("Save")}</Button>

          </Form >

          <Sidebar title={t("Select Multiple Users")} width="50%" isOpen={isModalVisible} onClose={() => setIsModalVisible(false)}>
            <SelectStaffs staffIds={staffIds} setStaffIds={setStaffIds} />
            {/* {staffIds?.length > 0 && <div className="bg-gradient-to-r from-pink-500 to-purple-500 text-white w-[90%] h-[2rem] flex items-center justify-center rounded-xl cursor-pointer absolute bottom-10" onClick={() => setIsModalVisible(false)}>Done</div>} */}
          </Sidebar >
        </div >
        <Modal
          open={configModel}
          onClose={() => closeConfigModel()}
          onCancel={() => closeConfigModel()}
          footer={null}
        >
          <ConfigurationCreateModel closeConfigModel={closeConfigModel} data={{ lineItems, staffIds }}
            configType="payroll" />
        </Modal>
      </AdminDashLayout >
    </Layout >
  );
};

export default AddPayrollManagement;
